import { API, graphqlOperation } from "aws-amplify";
import { updateComment as updateCommentMutation } from "../graphql/mutations";

export default async function updateComment(id) {
    let res = await API.graphql(graphqlOperation(updateCommentMutation, { input: { id: id, report: false } }));
    return res;
}